const AmericoProductData = () => {
  return {
    "minIssueAge": 20,
    "minFace": "$25000",
    "maxFace": "$1000000",
    "yearsLevel": null,
    "yearsGuaranteedLevel": null,
    "allowReentry": null,
    "policyMaturityAge": 0,
    "conversionOption": null,
    "minimumPremium": 0,
    "carrierID": 1013,
    "productName": "DecreasingTerm",
    "riderCost": null,
    "riderCostMonthly": null,
    "hasChildRider": false,
    "minChildRider": null,
    "maxChildRider": null,
    "coverageAmount": 0.0,
    "quoteID": null,
    "premiumWaiverAmount": 0.0,
    "jwtToken": null,
    "policyFee": null,
    "productInformation": "<li>Ages 20 to 65</li><li>Face Amounts from $25,000 to $1,000,000</li><li>Term periods include 5,7,10,15,20,25, and 30 year</li><li>Fixed level premiums</li><li>Digital self-directed application process</li>",
    "convertibility": "<li>Option to convert to permanent life insurance is not available</li>",
    "productDescription": "Americo's LoanMatch Protector helps protect your clients' assets whether it is for a Small Business loan to safeguard the economic future of the company or a Mortgage Loan to make sure their mortgage is paid in the event of their death.",
    "applicationInformation": "This product's application process can take up to 30 minutes to complete. Because this is an instant decision product, a medical exam is not required to qualify for coverage.",
    "hasPermConversionOption": false,
    "productRanges": null,
    "convertibilityScore": 0.0,
    "ridersScore": 0.0,
    "companyRatingsScore": 16.4,
    "noExamScore": 14.25,
    "digitalScore": 20.0,
    "speedScore": 34.25,
    "optionsScore": 0.0,
    "totalUnweightedScore": 50.65,
    "underwritingTimeTypical": "1-2 Days",
    "requiresMedicalExam": "No",
    "ratingAMBest": "A Excellent",
    "ratingSP": null,
    "ratingMoodys": null,
    "ratingFitch": null,
    "ratingComdex": null,
    "availableRiders": null,
    "disclosureDetail": null,
    "hasConvertibility": false,
    "subProductID": null,
    "underwritingType": 0,
    "productAppointments": [],
    "quoteLogId": null,
    "isDecreasingTerm": true,
    "requiresPhoneInterview": false,
    "isDigitalProduct": true,
    "productValueProposition": "<li>Digital application process with instant decisions</li><li>Competitive decreasing death benefit that matches mortgage or SBA loan</li><li>Innovative insurer for over 100 years</li>",
    "productHighlightInfo": [
        {
            "productHighlight": "Digital Application",
            "productHighlightDescription": "<p>Instead of traditional paper applications, applicants can complete and submit all the necessary information and documentation through a website, mobile app, or other digital platforms provided by insurance companies. These digital applications typically allow users to enter personal and medical information, select coverage options, and even undergo electronic underwriting, often speeding up the approval process. It offers a more convenient and efficient way for individuals to secure life insurance coverage.</p>"
        },
        {
            "productHighlight": "Decreasing Term",
            "productHighlightDescription": "<p>Decreasing term insurance is a type of life insurance policy where the death benefit gradually decreases over time, typically in sync with a specific financial obligation like a mortgage or a loan. The premiums remain constant, but the coverage amount decreases as the policy matures. This insurance is designed to provide financial protection for a specific debt or expense, ensuring that if the insured person passes away, the policy can help pay off the outstanding balance, making it an appropriate choice for individuals looking to cover a diminishing financial liability.</p>"
        }
    ]
  }
}

export default AmericoProductData;
